<div class="stock-modal-backdrop" *ngIf="isVisible" (click)="close()" (keydown.escape)="close()" tabindex="-1"
  aria-hidden="false">
  <section class="stock-modal-panel plan-modal-panel" role="dialog" aria-modal="true"
    aria-labelledby="edit-stock-modal-title" [attr.aria-busy]="uploading || loadingDetail ? 'true' : 'false'"
    (click)="$event.stopPropagation()">
    <div class="modal-layout plan-layout">
      <div class="full-width">
        <div class="role-banner admin" *ngIf="isAdminRole">
          Chế độ quản trị
        </div>

        <div class="info-header" *ngIf="isAdminRole">
          <div>
            <h2 id="edit-stock-modal-title">Cập nhật kế hoạch / kho hàng</h2>
            <p class="sub-text">
              Quản trị nhiều kho, hình ảnh và tổng kết giá trị kho
            </p>
          </div>
        </div>

        <div class="loading-state" *ngIf="loadingDetail">Đang tải dữ liệu kho...</div>
        <div class="error-state" *ngIf="errorMessage">{{ errorMessage }}</div>

        <form class="form-block" [formGroup]="planForm" *ngIf="!loadingDetail">
          <div class="form-row">
            <div class="form-field">
              <span>Tiêu đề</span>
              <span class="readonly-value">{{ planForm.get('title')?.value || '—' }}</span>
            </div>

            <div class="form-field">
              <span>Tên kho</span>
              <span class="readonly-value">{{ planForm.get('warehouseName')?.value || '—' }}</span>
            </div>
          </div>

          <div class="form-field">
            <span>Mô tả chung</span>
            <span class="readonly-value">{{ planForm.get('description')?.value || '—' }}</span>
          </div>

          <div class="section-header" *ngIf="isAdminRole">
            <h3>Danh sách kho</h3>
          </div>

          <div formArrayName="items" class="item-list">
            <div #itemCard class="item-card"
              *ngFor="let item of itemControls; let i = index; trackBy: trackByIndex" [formGroupName]="i">
              <div class="item-card-header">
                <h4>Kho {{ i + 1 }} <span class="item-id">#{{ item.get('id')?.value || '—' }}</span></h4>
                <div class="item-header-actions"  *ngIf="isAdminRole">
                  <div class="item-status">

                    <div class="toggle-field" >
                      <input type="checkbox" class="toggle-input" formControlName="isActive" />
                      <span class="toggle-label">

                        <span [class.text-success]="item.get('isActive')?.value">
                          {{ item.get('isActive')?.value ? 'Đang mở bán' : 'Đang khóa ' }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="item-body">
                <div class="item-media">
                  <div class="upload-block">
                    <div class="upload-header">
                      <h5>{{ (activePreviewIndexByItem[i] || 0) + 1 }}/{{ getPreviewItems(i).length }} </h5>
                    </div>

                    <!-- hide file input in readonly mode -->
                    <input #fileInput class="sr-only" type="file" [id]="'file-input-' + i" multiple
                      accept="image/*,video/*" (change)="onFileSelected($event, i)" [disabled]="true" />

                    <div class="preview-stage" *ngIf="getActivePreview(i) as preview; else noPreview">
                      <div class="preview-media" (swipeleft)="onSwipeLeft(i)" (swiperight)="onSwipeRight(i)">
                        <button *ngIf="getPreviewItems(i).length > 1" type="button" class="preview-nav preview-nav-prev"
                          (click)="onSwipeRight(i)" aria-label="Ảnh trước">
                          ‹
                        </button>

                        <img *ngIf="preview.type.startsWith('image/')" [src]="preview.preview" [alt]="preview.name" />

                        <video *ngIf="preview.type.startsWith('video/')" [src]="preview.preview" controls></video>

                        <button *ngIf="getPreviewItems(i).length > 1" type="button" class="preview-nav preview-nav-next"
                          (click)="onSwipeLeft(i)" aria-label="Ảnh kế tiếp">
                          ›
                        </button>
                      </div>
                    </div>

                    <ng-template #noPreview>
                      <div class="preview-empty">Kho này chưa có ảnh.</div>
                    </ng-template>
                  </div>
                </div>

                <div class="item-fields">
                  <div class="form-row form-row-1">
                    <div class="form-field">
                      <span class="required-label">Tên kho</span>
                      <span class="readonly-value">{{ item.get('name')?.value || '—' }}</span>
                    </div>
                  </div>

                  <div class="form-row form-row-2 form-row-type-unit">
                    <div class="form-field field-type">
                      <span>Loại sản phẩm</span>
                      <span class="readonly-value">{{ item.get('type')?.value || '—' }}</span>
                    </div>

                    <div class="form-field field-unit">
                      <span>Đơn vị</span>
                      <span class="readonly-value">{{ item.get('unit')?.value || '—' }}</span>
                    </div>
                  </div>

                  <div class="form-row form-row-2 form-row-pricing">
                    <div class="form-field field-retail">
                      <span class="required-label">Giá bán lẻ</span>
                      <span class="readonly-value">{{ getFormattedItemValue(i, 'retailPrice') || '0' }}</span>
                    </div>

                    <div class="form-field field-quantity">
                      <span class="required-label">Số lượng</span>
                      <span class="readonly-value">{{ getFormattedItemValue(i, 'quantity') || '0' }}</span>
                    </div>
                  </div>

                  <div class="form-row form-row-2 form-row-stock-flow">
                    <div class="form-field field-wholesale">
                      <span class="required-label">Tổng nhập sỉ (VNĐ)</span>
                      <span class="readonly-value">{{ formatCurrency(getItemWholesale(item)) }}</span>
                    </div>

                    <div class="form-field field-sold" *ngIf="!isAdminRole">
                      <span>Đã bán</span>
                      <span class="readonly-value">{{ getFormattedItemValue(i, 'soldQty') || '0' }}</span>
                    </div>

                    <label class="form-field field-sold" *ngIf="isAdminRole">
                      <span>Đã bán</span>
                      <input
                        type="text"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        maxlength="12"
                        placeholder="0"
                        [value]="getFormattedItemValue(i, 'soldQty')"
                        (input)="onFormattedNumberInput($event, i, 'soldQty')" />
                    </label>
                  </div>

                  <div class="form-field">
                    <span>Ghi chú</span>
                    <span class="readonly-value">{{ item.get('note')?.value || '—' }}</span>
                  </div>

                  <div class="item-summary">
                    <div class="summary-chip">
                      <span>Doanh thu bán lẻ</span>
                      <strong>{{ formatCurrency(getItemRevenue(item)) }}</strong>
                    </div>

                    <div class="summary-chip">
                      <span>Vốn nhập</span>
                      <strong>{{ formatCurrency(getItemWholesale(item)) }}</strong>
                    </div>

                    <div class="summary-chip profit">
                      <span>Lợi nhuận</span>
                      <strong>{{ formatCurrency(getItemProfit(item)) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </form>

        <div class="form-actions">
          <button type="button" class="button close-button" (click)="close()" [disabled]="uploading || deleting">
            Đóng
          </button>

          <button type="button" class="primary-btn" (click)="submit()" *ngIf="isAdminRole">
            <span *ngIf="!uploading">Lưu kế hoạch</span>
            <span *ngIf="uploading">⏳ Đang lưu...</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
